import { ReviewCreationData } from '../../../types/review-creation-data';
import type { ReviewImage } from './parse-review-form-data';

export const createReview = async (
    reviewCreationData: ReviewCreationData,
    images: ReviewImage[] = [],
    multipartUploadActive = false
): Promise<Response> => {
    if (multipartUploadActive) {
        const formData = new FormData();
        formData.append('review', JSON.stringify(reviewCreationData));
        for (const { file, position } of images) {
            formData.append(`image_${position}`, file);
        }

        return await fetch('/cr-review-submission/review/v1', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
            },
            body: formData,
        });
    }

    const imagesBase64 = await Promise.all(
        images.map(async ({ file, position }) => ({ imageBase64: await fileToBase64DataURL(file), position }))
    );
    return await fetch('/cr-review-submission/review/v1', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({ ...reviewCreationData, images: imagesBase64.length > 0 ? imagesBase64 : undefined }),
    });
};

const fileToBase64DataURL = (file: File): Promise<string> =>
    new Promise(resolvePromise => {
        const reader = new FileReader();
        reader.onload = () => {
            resolvePromise(reader.result as string);
        };
        reader.readAsDataURL(file);
    });
